module.exports = __webpack_public_path__ + "static/media/3DPPA42.e0fde6c9.jpg";